module.exports = __webpack_public_path__ + "static/media/getTheLink.ff007413.svg";